import { useState } from 'react';
import { Link } from 'react-router-dom';
import { ui } from './envUi';
import AdminSurvey from './AdminSurvey';
import AdminResponses from './AdminResponses';

/** Admin mode inside the survey: edit / remove questions and review responses. */
export default function SurveyAdmin() {
  const [tab, setTab] = useState<'questions' | 'responses'>('questions');

  return (
    <div>
      <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          <span className="rounded-full bg-yellow-400 px-3 py-1 text-xs font-bold uppercase tracking-wide text-black">Admin mode</span>
          <span className={ui.muted}>Changes apply to the survey straight away.</span>
        </div>
        <div className="flex items-center gap-2">
          <Link to="/environmental/admin" className={ui.btnGhost}>All admin settings</Link>
        </div>
      </div>

      <div role="tablist" className="mb-6 flex gap-1 border-b border-slate-200 dark:border-slate-800">
        {([['questions', 'Questions'], ['responses', 'Responses']] as const).map(([id, label]) => (
          <button key={id} role="tab" aria-selected={tab === id} onClick={() => setTab(id)}
                  className={`-mb-px border-b-2 px-4 py-2.5 text-sm font-semibold transition-colors
                              ${tab === id ? 'border-yellow-500 text-slate-900 dark:text-slate-100' : 'border-transparent text-slate-500 dark:text-slate-400 hover:text-slate-800 dark:hover:text-slate-100'}`}>
            {label}
          </button>
        ))}
      </div>

      {tab === 'questions' ? <AdminSurvey /> : <AdminResponses />}
    </div>
  );
}
